import React, { Component } from 'react';
import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';
import { AreaInput, TextInput } from '../../../lib/components/textInput';

/* React Router */
import { withRouter } from 'react-router-dom'

/* Result */
import Result from 'iotera-base/result'

/* Redux */
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';

/* Sagas Action */
import { buildWBoundActions, buildWSelector } from '../../../redux/ducks'
import { actions as notificationActions } from '../../../redux/ducks/notification'

/* Routes */
import { domainIsTenant as dit, S } from '../../../routes/routes'

/* Object Json */
import { _N, isEmpty } from 'iotera-base/object';
import { parseAny, stringify, safeGet, safeGetWithType } from 'iotera-base/json';
import { IoteraForm } from '../../../lib/components/form';
import { SubViewHeader } from '../../../lib/components/subHeader';
import { InputLabel, Select, Chip, MenuItem, Checkbox, ListItemText, FormControl } from '@material-ui/core';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../../lib/components/callbackGlobal';

const EDIT = "EDIT";
const WKEY = "ROLE_EDIT";
const wSelector = buildWSelector(WKEY);
const wBoundActions = buildWBoundActions(WKEY);

const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  palette: {
    primary: {
      main: '#4D2C91'
    },
    secondary: {
      main: '#fff',
    },
    grey: {
      "100": '#7E57C2'
    }
  },
  overrides: {
    MuiTabs: {
      root: {
        backgroundColor: '#ffffff'
      }
    },
    MuiListItemIcon: {
      root: {
        color: '#000',
        marginRight: 8
      },
    },
    MuiTooltip: {
      tooltipPlacementBottom: {
        margin: '4px 0'
      },
      tooltipPlacementRight: {
        margin: '0 4px'
      },
      tooltipPlacementLeft: {
        margin: '0 4px'
      },
      tooltipPlacementTop: {
        margin: '4px 0'
      },
      tooltip: {
        backgroundColor: '#6F6F6F',
      }
    },
    // For Limit Height of Material Ui Select 
    MuiList: {
      root: {
        maxHeight: '368px'
      }
    },
    MuiStepper: {
      root: {
        display: 'flex',
        padding: 16
      }
    },
    MuiStepLabel: {
      label: {
        color: '#979CA4',
        "&.MuiStepLabel-active": {
          color: '#F5F6F7',
          fontWeight: 500
        },
        "&.MuiStepLabel-completed": {
          color: '#F5F6F7',
          fontWeight: 500
        },
        "&.MuiStepLabel-alternativeLabel": {
          marginTop: 5,
          textAlign: 'center'
        }
      }
    },
    MuiOutlinedInput: {
      input: {
        padding: 10
      }
    },
    MuiInputLabel: {
      outlined: {
        top: 5,
        position: 'relative'
      }
    }
  }
})

const onError = (errors) => console.log("Ada", errors.length, "error yang harus diperbaiki");

function schema() {
  return {
    type: "object",
    required: ["name", "permissions"],
    properties: {
      name: { type: "string", minLength: 1, maxLength: 30, pattern: '^[A-Za-z\\d][A-Za-z\\d_]+$' },
      description: { type: "string", default: '' },
      permissions: { type: 'string', title: 'Permissions', default: '{}' },
    }
  }
};

function uiSchema() {
  return {
    name: {
      "ui:widget": (props) => {
        return (
          <TextInput
            id="name"
            type="text"
            label="Nama"
            placeholder="Admin"
            textTooltip="Masukkan nama untuk identifikasi role ini"
            value={props.value}
            onError={onError}
            required={props.required}
            onChange={event => props.onChange(event.target.value)}
          />
        )
      },
      "ui:options": {
        label: false
      }
    },
    description: {
      "ui:widget": (props) => {
        return (
          <TextInput
            id="description"
            type="text"
            label="Deskripsi"
            placeholder="Deskripsi role"
            textTooltip="Masukkan deskripsi untuk role ini"
            value={props.value}
            onError={onError}
            required={props.required}
            onChange={event => props.onChange(event.target.value)}
          />
        )
      },
      "ui:options": {
        label: false
      }
    },
    permissions: {
      'ui:widget': props => {
        return (
          <AreaInput
            id="permissions"
            type="text"
            label="Permissions"
            textTooltip="Permissions"
            value={props.value}
            required={props.required}
            onChange={event => props.onChange(event.target.value)}
            areaHeight={200}
            {...props}
          />
        );
      },
      'ui:options': {
        label: false,
      },
    },
  }
};

class RoleEdit extends Component {
  constructor(props) {
    super(props)
    const roleId = safeGet(this, ['props', 'match', 'params', 'id']);
    this.state = {
      value: [],
      formData: {},
      values: '',
      isSubmit: false,
      roleId,
      loading: true
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    const { roleId } = _state;
    if (isEmpty(roleId)) {
      return {}
    }
    const domainIsTenant = dit(_props);
    // callback global
    setCallbackGlobal(_props)
    _props.wInitRequestCall(
      {
        wparam: { ...domainIsTenant, path: "/service/web/application/account/role/get/id/" + roleId },
        wcallback: {
          started: function (id) {
            // TODO Loading
          },
          finished: function (id, result) {
            if (result.code === Result.HTTP.OK) {
              const responseResult = safeGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
              if (responseResult === Result.SUCCESS) {
                const sys_navs_server = safeGetWithType(result, ['body', 'sys_navs'], [])
                let sys_navs = [];
                let sys_navs_opt = {};
                for (let i = 0; i < sys_navs_server.length; i++) {
                  let sys_id = safeGetWithType(sys_navs_server, [i, 'id'], '');
                  let sys_label = safeGetWithType(sys_navs_server, [i, 'label'], '');
                  let sys_checked = safeGetWithType(sys_navs_server, [i, 'checked'], false);
                  if (sys_checked) {
                    sys_navs.push(sys_id);
                  }
                  sys_navs_opt[sys_id] = {
                    label: sys_label
                  }
                }

                if (sys_navs_server.length > 0) {
                  _this.setState({ sys_navs, sys_navs_opt })
                }
              }
            }
            // TODO Loading
            _this.setState({
              loading: false
            })
          }
        }
      }
    );
    _props.wSetConfig({
      single_config: {
        [EDIT]: {
          wparam: {
            ...domainIsTenant,
            method: "POST",
            path: "/service/web/application/account/role/edit"
          },
          wcallback: {
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === Result.SUCCESS) {
                  _this.setState({
                    loading: false
                  })
                  _props.history.push('..' + S + '_role_list_')
                  _props.showSingleNotification({ message: 'Edit Role Sukses', level: 'success' });
                  return;
                }
              }
              _this.setState({
                loading: false
              })
              _props.showSingleNotification({ message: 'Edit Role Gagal', position: 'tr', level: 'error' });
            }
          }
        }
      }
    });
  }

  componentWillUnmount() {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    const { roleId } = _state;
    if (isEmpty(roleId)) {
      return {}
    }
    // callback global
    unsetCallbackGlobal(_props)
    _props.wUnsetConfig({ key: WKEY });
  }

  handleSubmit(event) {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    let submitData = event['formData'];
    const name = submitData['name'];
    const description = submitData['description'];
    const permissions = submitData['permissions'];
    const permissionsParsed = parseAny(permissions);

    if (_N(permissionsParsed)) {
      _props.showSingleNotification({
        message: 'Invalid JSON for `Permissions`',
        level: 'warning',
      });
      return;
    }

    const sys_navs = safeGetWithType(_state, ['sys_navs'], []);
    const id = _props.roleId;
    _this.setState({
      loading: true
    })
    _props.wSingleRequestCall({
      id: EDIT,
      body: {
        id,
        name,
        description,
        sys_navs,
        permissions: permissionsParsed
      }
    });
  }

  handleChange(event) {
    const name = safeGetWithType(event, ['target', 'name'], '')
    const value = safeGet(event, ['target', 'value'], '')
    this.setState({ [name]: value })
  }

  goTo(link) {
    this.props.history.push(link)
  }

  render() {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    const { loading } = _state;
    let dataToShow = {};
    if (isEmpty(_state.formData)) {
      dataToShow = {}  
    } else    {
      dataToShow = _state.formData;
    }
    const spinner =
      <div className='centeringItem'>
        <ReactLoading type='bubbles' color='#000' />
      </div>
    const role = safeGetWithType(_props, ['role'], {});

    dataToShow.name = safeGetWithType(role, ['name'], '');
    dataToShow.description = safeGetWithType(role, ['description'], '');
    dataToShow.permissions = stringify(safeGetWithType(role, ['permissions'], {}));
    let sys_navs = safeGetWithType(_state, ['sys_navs'], []);
    let sys_navs_opt = safeGetWithType(_state, ['sys_navs_opt'], {});
    let menu_navs = []
    for (let key in sys_navs_opt) {
      let sys_nav = sys_navs_opt[key];
      menu_navs.push(
        <MenuItem key={key} value={key}>
          <Checkbox color='primary' checked={sys_navs.indexOf(key) > -1} />
          <ListItemText primary={sys_nav.label} />
        </MenuItem>
      )
    }
    return (
      <MuiThemeProvider theme={theme}>
        <Loader show={loading} message={spinner} backgroundStyle={{ backgroundColor: '#ffffff', opacity: 0.3 }}>
          <div className="view">
            <SubViewHeader title='Edit Role' subTitle='Formulir Edit Role' />
            <div className="io-container mt-12">
              <IoteraForm
                schema={schema()}
                uiSchema={uiSchema()}
                onSubmit={_this.handleSubmit}
                formData={dataToShow}
              >
                <FormControl variant="outlined" style={{ minWidth: '100%', marginBottom: 5, marginTop: 10 }}>
                  <InputLabel >Sistem Navigasi</InputLabel>
                  <Select
                    multiple
                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    value={sys_navs}
                    onChange={_this.handleChange}
                    inputProps={{
                      name: 'sys_navs'
                    }}
                    renderValue={selected => (
                      < div >
                        {
                          selected.map((value) =>
                          (
                            <Chip key={value} label={sys_navs_opt[value].label} style={{ marginLeft: 5 }} />
                          ))
                        }
                      </div>
                    )}
                  >
                    {menu_navs}
                  </Select>
                </FormControl>
                <div className="button-right" style={{ marginTop: 10 }}>
                  <button className="button-iotera-white" type="button" style={{ minWidth: '0%' }}
                    onClick={(e) => _this.goTo('..' + S + '_role_list_')} >Batal</button>
                  <button className="button-iotera-primary" type="submit" style={{ marginLeft: 10, minWidth: '0%' }}>Simpan</button>
                </div>
              </IoteraForm>
            </div>
          </div>
        </Loader >
      </MuiThemeProvider >
    );
  }
}

const mapStateToProps = function (state, ownProps) {
  return {
    role: wSelector.getSoleInitMappedRPayload(state),
    roleId: wSelector.getSoleInitMappedRPayload(state, 'id')
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(notificationActions, dispatch)
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RoleEdit));